import { StandardEvents } from '@shopify/events';

const initializeMobSkuContact = (root) => {
  if (root.dataset.mobSkuReady === 'true') return;
  root.dataset.mobSkuReady = 'true';

  const variants = JSON.parse(root.querySelector('[data-mob-variants]').textContent);
  const emailLink = root.querySelector('[data-mob-email]');
  const textLink = root.querySelector('[data-mob-text]');
  const skuElement = root.querySelector('[data-mob-selected-sku]');
  let selectionGeneration = 0;

  const currentVariantId = () => {
    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    const productFormVariant = document.querySelector('#MainContent form[action*="/cart/add"] [name="id"]')?.value;
    return String(urlVariant || productFormVariant || variants[0]?.id || '');
  };

  const updateLinks = (variantId = currentVariantId()) => {
    const variant = variants.find((item) => String(item.id) === String(variantId));
    if (!variant) {
      skuElement.textContent = root.dataset.missingLabel;
      for (const link of [emailLink, textLink]) {
        link?.removeAttribute('href');
        link?.setAttribute('aria-disabled', 'true');
      }
      return;
    }

    const sku = variant.sku || root.dataset.missingLabel;
    const title = root.dataset.productTitle;
    const variantTitle = variant.title === 'Default Title' ? '' : variant.title;
    const productUrl = new URL(root.dataset.productUrl);
    productUrl.searchParams.set('variant', variant.id);

    const lines = [
      `Product: ${title}`,
      variantTitle ? `Variant: ${variantTitle}` : '',
      `SKU: ${sku}`,
      `Link: ${productUrl.toString()}`,
    ].filter(Boolean);
    const message = lines.join('\n');

    skuElement.textContent = sku;

    if (emailLink) {
      const subject = `Question about ${title} — SKU ${sku}`;
      emailLink.href = `mailto:${root.dataset.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
      emailLink.removeAttribute('aria-disabled');
    }

    if (textLink) {
      const separator = /iPad|iPhone|iPod/.test(navigator.userAgent) ? '&' : '?';
      textLink.href = `sms:${root.dataset.phone}${separator}body=${encodeURIComponent(message)}`;
      textLink.removeAttribute('aria-disabled');
    }
  };

  document.addEventListener(StandardEvents.productSelect, async (event) => {
    const source = event.target;
    if (!root.isConnected || !(source instanceof Element)) return;
    if (source.closest('product-card, dialog')) return;
    if (!source.closest('#MainContent .product-information')) return;

    const generation = ++selectionGeneration;

    try {
      const { detail } = await event.promise;
      if (!root.isConnected || generation !== selectionGeneration || !detail) return;
      const eventProductId = detail.newProduct?.id ?? detail.productId;
      if (eventProductId != null && String(eventProductId) !== root.dataset.productId) return;
      updateLinks(detail.resource?.id ?? null);
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[mob-sku-contact] Variant update failed:', error);
    }
  });

  window.addEventListener('popstate', () => {
    selectionGeneration += 1;
    updateLinks();
  });
  updateLinks();
};

document.querySelectorAll('[data-mob-sku-contact]').forEach(initializeMobSkuContact);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-mob-sku-contact]').forEach(initializeMobSkuContact);
});
